import { render } from "./ManageWorkspaces.vue?vue&type=template&id=74930039&scoped=true"
import script from "./ManageWorkspaces.vue?vue&type=script&lang=js"
export * from "./ManageWorkspaces.vue?vue&type=script&lang=js"

import "./ManageWorkspaces.vue?vue&type=style&index=0&id=74930039&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74930039"]])

export default __exports__